<div class="mt-3 -mb-3 grid grid-nogutter">
  <div class="col-10 col-offset-1">
    <p-messages key="profileMessages" [closable]="false" data-cy="profile-messages-container"></p-messages>
  </div>
</div>
<app-page title="Patient Profile">
  <p-tabMenu [model]="tabItems" [activeItem]="activeTabItem" styleClass="mb-4"></p-tabMenu>
  <p-card styleClass="card-min-h" data-cy="profile-container">
    <router-outlet></router-outlet>
  </p-card>
  <br /><br />
  <br /><br />
  <div *ngIf="isPharmPatient" class="text-center">
    <p class="p8 font-semibold my-0">
      Our systems will take up to 2 business days to update. Please contact us at 888.308.8882 if you have any
      concerns/questions. Thank you!
    </p>
  </div>
</app-page>
